module.exports = __webpack_public_path__ + "static/XP Eagle gradient-039a18f39d22b9ec729bdc7088e37a20.png";